






import moment from 'moment';
import { Chart, registerables } from 'chart.js';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ArrivingDepartingGraph } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly startDate: string;
  @Prop({ required: true }) readonly endDate: string;

  canvas: HTMLCanvasElement | null = null;
  chart!: Chart;
  graph: ArrivingDepartingGraph | null = null;

  get labels() {
    if (!this.graph) {
      return;
    }

    return this.graph.labels.map((e: string) => moment(e).format('D/MM/YYYY'));
  }

  get arrivalData() {
    if (!this.graph) {
      return;
    }
    return this.graph.values.arrival;
  }
  get departureData() {
    if (!this.graph) {
      return;
    }
    return this.graph.values.departure;
  }

  updateChart() {
    if (!this.chart) {
      return;
    }

    const chartData = {
      labels: this.labels,
      datasets: [
        {
          label: 'Departing Hobart',
          data: this.departureData || [],
          borderWidth: 1,
          fill: false,
          borderColor: '#6EC56E',
          backgroundColor: 'rgba(110, 197, 110, .3)',
        },
        {
          label: 'Returning Hobart',
          data: this.arrivalData || [],
          borderWidth: 1,
          fill: false,
          borderColor: '#EA3035',
          backgroundColor: 'rgba(234, 48, 53, .3)',
        },
      ],
    };

    this.chart.data = chartData;
    this.chart.update();
  }

  async getReportData() {
    try {
      this.graph = new ArrivingDepartingGraph({
        startDatetime: this.startDate,
        endDatetime: this.endDate,
      });
      await this.graph.save();
      this.updateChart();
    } catch (err) {
      // Graph not found
    }
  }

  mounted() {
    Chart.register(...registerables);

    this.canvas = document.getElementById(
      'arriving-departing-canvas',
    ) as HTMLCanvasElement | null;

    if (this.canvas) {
      this.chart = new Chart(this.canvas, {
        type: 'bar',
        data: {
          datasets: [],
        },
        options: {
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: true,
              ticks: {
                display: false,
              },
            },
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
            },
          },
          hover: {
            mode: 'index',
            intersect: false,
          },
        },
      });

      this.getReportData();
    }
  }

  @Watch('startDate')
  @Watch('endDate')
  dateChanged() {
    this.getReportData();
  }
}
